<template>
	<div>
		<modalconfirm ref="modalconfirmPO" @action="proccessPO"/>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'list-purchase-order'">Data Pemesanan</div>
			<div class="text-h5" v-else-if="$route.name == 'list-purchase-order-warehouse'">Data Pemesanan Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-purchase-order' }" v-if="hasAccess('add-purchase-order')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Pemesanan</div>
							</v-btn>
						</router-link>
						<div class="ml-4">
							<v-tabs color="primary" background-color="deep-purple lighten-5" class="change-display" height="40">
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4 pb-1">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Kode Pemesanan" v-model="po_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3" >
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalPO)" label="Tanggal Pemesanan" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal" hide-details></v-text-field>
									</template>
									<v-date-picker locale="id" first-day-of-week="0" range color="primary" v-model="tanggalPO" :max="today"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="5">
								<v-autocomplete item-text="status" item-value="code" outlined dense hide-details v-model="po_status.value" :items="status_list" label="Status" class="width-0" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete outlined dense hide-details v-model="payment_type.value" :items="payment_list" label="Tipe Pembayaran" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete outlined dense hide-details v-model="supplier.value" :items="supplierResults" label="Supplier" item-text="supplier_name" item-value="supplier_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete v-if="$route.name == 'list-purchase-order-warehouse'" outlined dense hide-details v-model="po_warehouse.value" :items="warehouseResults" label="Warehouse" item-text="warehouse_name" item-value="warehouse_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table loading :headers="headers" :items="listPO" hide-default-footer :options.sync="option" :server-items-length="poPagination.total_data" disable-pagination>
					<template v-slot:item.created_datetime="{ item }">
						<div class="pt-2">{{ item.po_status_created_datetime | tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn x-small dense text color="grey darken-1" v-bind="attrs" v-on="on" @click="printPO(item.po_warehouse_id, item.po_code)"><v-icon>mdi-printer</v-icon></v-btn>
								</template>
								<span>Print</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:item.po_code="{ item }">
						<div>{{ item.po_code }}</div>
					</template>
					<template v-slot:item.supplier="{ item }">
						<div class="py-2">
							<div>{{ item.supplier_name }}</div>
							<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.supplier_mobilephone }}</span></div>
							<div class="pt-1"><v-icon small>mdi-email</v-icon><span class="pl-2">{{ item.supplier_email }}</span></div>
						</div>
					</template>
					<template v-slot:item.warehouse="{ item }" v-if="$route.name == 'list-purchase-order-warehouse'">
						<div class="text-capitalize">{{ item.warehouse_name }}</div>
					</template>
					<template v-slot:item.payment_method="{ item }">
						<div class="text-capitalize">{{ item.po_payment_method }}</div>
					</template>
					<template v-slot:item.status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.po_status | toStatusPOWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.po_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
							<v-tooltip bottom v-if="item.po_status == 'created' && hasAccess('approval-purchase-order')">
								<template v-slot:activator="{ on, attrs }">
									<router-link class="text-deco" :to="{ name: 'approval-purchase-order', params: { code: item.po_code }}">
										<v-btn class="mr-1" fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
											<v-icon dark>mdi-check</v-icon>
										</v-btn>
									</router-link>
								</template>
								<span>Approval</span>
							</v-tooltip>
							<v-tooltip bottom v-if="item.po_status == 'created' && hasAccess('add-purchase-order')">
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="pink" @click="hapus(item.po_id)" v-bind="attrs" v-on="on">
										<v-icon dark>mdi-delete</v-icon>
									</v-btn>
								</template>
								<span>Hapus</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!poPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card outlined v-if="listPO.length == 0 && poPagination">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<v-card outlined v-else-if="listPO.length == 0 && !poPagination">
					<div class="py-3">
						<loading-data></loading-data>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="po in listPO" :key="po.po_id">
					<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Pemesanan {{ po.po_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="primary" @click="printPO(po.po_warehouse_id, po.po_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Supplier</div>
									<div class="subtitle-2">{{ po.supplier_name }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tanggal Pemesanan</div>
									<div class="subtitle-2">{{ po.po_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tipe Pembayaran</div>
									<div class="subtitle-2 text-capitalize">{{ po.po_payment_method }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ po.po_status | toStatusPOWH }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 pt-3">
										<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ po.supplier_mobilephone }}</span>
									</div>
									<div class="body-2 pt-1">
										<v-icon small>mdi-email</v-icon><span class="pl-2">{{ po.supplier_email }}</span>
									</div>
								</v-flex>
								<v-flex xs3 sm6 md6 class="pt-3">
									<div class="text-h5" v-if="$route.name == 'list-purchase-order-warehouse'">
										<div class="body-2 oppacity-75">Warehouse Tujuan</div>
										<div class="subtitle-2">PUSAT KE {{ po.warehouse_name }}</div>
									</div>
								</v-flex>
								<v-flex xs3 sm3 md3>
									<div class="pt-4">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(po.po_code)" class="mr-2">
													<v-icon dark>mdi-text-box-search</v-icon>
												</v-btn>
											</template>
											<span>Detail</span>
										</v-tooltip>
										<v-tooltip bottom v-if="po.po_status == 'created' && hasAccess('approval-purchase-order')">
											<template v-slot:activator="{ on, attrs }">
												<router-link class="text-deco" :to="{ name: 'approval-purchase-order', params: { code: po.po_code }}">
													<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on" class="mr-2">
														<v-icon dark>mdi-check</v-icon>
													</v-btn>
												</router-link>
											</template>
											<span>Approve</span>
										</v-tooltip>
										<v-tooltip bottom v-if="po.po_status == 'created' && hasAccess('add-purchase-order')">
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="pink lighten-2" @click="hapus(po.po_id)" v-bind="attrs" v-on="on" class="mr-2">
													<v-icon dark>mdi-delete</v-icon>
												</v-btn>
											</template>
											<span>Hapus</span>
										</v-tooltip>
									</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
					<div class="pt-3">
						<v-card tile elevation="0">
							<v-data-table :headers="headersProduct" :items="po.po_detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
								<template v-slot:item.po_detail_product_price="{ item }">
									<div>{{ item.po_detail_product_price | toNumber }}</div>
								</template>
								<template v-slot:item.po_detail_quantity_requested="{ item }">
									<div v-if="po.po_status == 'created'">
										{{ item.po_detail_quantity_requested | toNumber }} {{ item.po_detail_product_unit }}
									</div>
									<div v-else>
										{{ item.po_detail_quantity_approved | toNumber }} {{ item.po_detail_product_unit }}
									</div>
								</template>
								<template v-slot:item.po_detail_quantity_delivered="{ item }">
									<div>{{ item.po_detail_quantity_delivered | toNumber }} {{ item.po_detail_product_unit }}</div>
								</template>
								<template v-slot:item.po_detail_quantity_transport="{ item }">
									<div>{{ item.po_detail_quantity_transport | toNumber }} {{ item.po_detail_product_unit }}</div>
								</template>
								<template v-slot:item.sub_total="{ item }">
									<div v-if="po.po_status == 'created'">
										{{ item.po_detail_quantity_requested * item.po_detail_product_price | toNumber }}
									</div>
									<div v-else>
										{{ item.po_detail_quantity_approved * item.po_detail_product_price | toNumber }}
									</div>
								</template>
							</v-data-table>
							<!-- <div class="d-flex justify-end py-2">
								<div class="font-weight-bold text-right px-4">Total Pembayaran</div>
								<div class="font-weight-bold text-right px-4">{{ countGrandtotal(po.po_detail, po.po_status) | toRupiah }}</div>
							</div> -->
						</v-card>
					</div>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row v-if="poPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="poPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import modalDetail from '@/views/MLwarehouse/po/DetailPO'
import modalPrint from '@/views/MLwarehouse/po/ModalPrintPO'
const headerPO = [
	{ text: 'Tanggal Pemesanan', value: 'created_datetime' },
	{ text: 'Kode Pemesanan', sortable: true, value: 'po_code'},
	{ text: 'Supplier', value: 'supplier'},
	{ text: 'Tipe Pembayaran', value: 'payment_method' },
	{ text: 'Status', value: 'status' },
]
const headerPOWarehouse = [
	{ text: 'Tanggal Pemesanan', value: 'created_datetime' },
	{ text: 'Kode Pemesanan', sortable: true, value: 'po_code'},
	{ text: 'Supplier', value: 'supplier'},
	{ text: 'Warehouse Tujuan', value: 'warehouse'},
	{ text: 'Tipe Pembayaran', value: 'payment_method' },
	{ text: 'Status', value: 'status' },
]

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: true,
			menu: false,
			loading: true,
			tanggalPO: [],
			payment_list: ['Lunas', 'Tempo'],
			po_code: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_code'
			},
			po_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'po_status_created_datetime'
			},
			payment_type: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_payment_method'
			},
			supplier: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_supplier_id'
			},
			po_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_status'
			},
			po_warehouse: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_warehouse_id'
			},
			sortBy: 'po_id',
			sortDir: 'DESC',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			headersProduct: [
			{ text: 'Nama Produk', value: 'po_detail_product_name', sortable: false },
			{ text: 'Jumlah Pesanan', value: 'po_detail_quantity_requested', align: 'center', sortable: false },
			{ text: 'Jumlah Diterima', value: 'po_detail_quantity_delivered', align: 'center', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'po_detail_quantity_transport', align: 'center', sortable: false },
			],
			params:[],
			procces_po_id: '',
			poProccess : '',
		}
	},
	computed: {
		...mapState('po', ['listPO', 'poPagination', 'OptionStatusPO', 'supplierResults', 'warehouseResults']),
		...mapState('auth', ['userData']),

		headers() {
			if (this.$route.name == 'list-purchase-order')
				return headerPO
			else if (this.$route.name == 'list-purchase-order-warehouse')
				return headerPOWarehouse
			else return []
		},

		status_list() {
			return this.OptionStatusPO.map( (el) => {
				return {
					code: el,
					status: this.$options.filters.toStatusPOWH(el)
				}
			})
		}

	},
	methods: {
		...mapActions('po', ['getPO', 'getPOAll', 'deletePO', 'getDetailPO', 'exportPO', 'getOptionStatusPO', 'getSupplierOption', 'getWarehouseOption', 'exportPOAll']),
		...mapMutations('po', ['clearDataPO']),
		...mapActions('common', ['getLetterHeader']),
		...mapMutations(['setOverlay']),

		exportData() {
			if (this.$route.name == 'list-purchase-order-warehouse') {
				this.exportPOAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == "list-purchase-order") {
				this.exportPO(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		countGrandtotal(item, status) {
			let total = 0
			item.forEach( (el) => {
				let price = el.po_detail_product_price ? el.po_detail_product_price : 0
				let quantity = status == 'created' ? el.po_detail_quantity_requested : el.po_detail_quantity_approved
				total += price * quantity
			});

			return total
		},
		async getData() {
			await this.getDataPO()
			await this.getOptionStatusPO()
			await this.getSupplierOption()
			await this.getWarehouseOption()
			this.loading = await false

		},
		getDataPO() {
			if (this.$route.name == "list-purchase-order") {
				this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == "list-purchase-order-warehouse") {
				this.getPOAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		resetFilter() {
			this.po_code.value = ''
			this.po_date.value = ''
			this.tanggalPO = []
			this.payment_type.value = ''
			this.po_status.value = ''
			this.supplier.value = ''
			this.po_warehouse.value = ''
			this.page = 1
			this.getDataPO()
		},
		cari() {
			this.params = []
			if (this.po_code.value)
				this.params.push(this.po_code)
			if (this.po_date.value) {
				this.po_date.value.sort()
				let date = this.po_date.value.join('::')
				this.po_date.value = date
				this.params.push(Object.assign({}, this.po_date))
			}
			if (this.payment_type.value)
				this.params.push(this.payment_type)
			if (this.supplier.value)
				this.params.push(this.supplier)
			if (this.po_warehouse.value)
				this.params.push(this.po_warehouse)
			if (this.po_status.value)
				this.params.push(this.po_status)
			this.page = 1
			this.getDataPO()
		},
		changePage(page) {
			this.page = page
			this.getDataPO()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getDataPO()
		},
		hapus(val) {
			this.procces_po_id = val
			this.poProccess = 'delete'
			let msg = "Yakin akan menghapus Pemesanan ini?"
			this.$refs.modalconfirmPO.showConfirm()
			this.$refs.modalconfirmPO.setMessage(msg)
		},
		async proccessPO() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmPO.hideConfirm()
			if (this.poProccess == 'delete') {
				await this.deletePO(this.procces_po_id).then( () => {
					this.getDataPO()
				})
			}
			await this.setOverlay(false)
		},
		getDetail(code) {
			this.getDetailPO(code).then(()=> {
				this.dialog = true
			})
		},
		async printPO(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailPO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Pemesanan`)
		this.getData()
	},
	beforeDestroy() {
		this.clearDataPO()
	},
	watch: {
		tanggalPO(val) {
			this.po_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getDataPO()
			}
		},
		$route() {
			this.resetFilter()
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>